/**
 * CockpitPerformanceResponse
 * @author ftgibran
 */
import {Model, IResource, Collection, Dictionary, $} from 'simpli-web-sdk'
import * as Helper from '@/helpers'
import CockpitRequest from '@/model/request/CockpitRequest'

export interface Stats {
  nome: string | null
  iniciadas: number | null
  emRota: number | null
  aguardandoRota: number | null
}

export default class CockpitPerformanceResponse extends Model {
  readonly $name: string = 'CockpitPerformanceResponse'

  row: Stats[] = []

  async getCockpitPerformancePorOrigem(request: CockpitRequest, spinner = 'getCockpitPerformance') {
    const fetch = async () => await this.POST(`/user/me/cockpit/performance/origem`, request)
    return await $.await.run(fetch, spinner)
  }

  async getCockpitPerformancePorEmbarcador(request: CockpitRequest, spinner = 'getCockpitPerformance') {
    const fetch = async () => await this.POST(`/user/me/cockpit/performance/embarcador`, request)
    return await $.await.run(fetch, spinner)
  }
}
